import request from '../../../shared/request'

export function getTickets(jobId) {
  return request(`/job/ticket/${jobId}/`)
}

export function createTicket(payload) {
  return request(`/job/ticket/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateTicket(payload) {
  return request(`/job/ticket/${payload.ticketId}/`, {
    method: 'PUT',
    body: payload.content,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTicket(payload) {
  return request(`/job/ticket/${payload.ticketId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/ticket/${payload.ticketId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(ticketId) {
  return request(`/job/ticket/${ticketId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/ticket/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/ticket/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/tickets.js